<tcc-simplePanel size="full" [options]="{respondsToMainMenu: true}">
  <div panel-header>
    <ng-container>{{(org$ | async)?.name}}</ng-container> Revenue 
  </div>
  <div panel-subheader *ngIf="(state$ | async) !== 'loading'">
    <div class="d-flex">
      <div class="flex-grow-1 d-flex flex-row flex-wrap align-items-center" style="column-gap: .75rem; row-gap: .5rem"
        *ngIf="orgArea">

        <div class="border rounded bg-white px-2 py-1" [ngClass]="getTargetEstimateClass(estimateTypeEnumRef.TargetRenewalPct)">
            <label class="d-block small font-weight-bold mb-1" tccLabelForNext>Renewal Target</label>
            <div class="input-group input-group-sm">
              <input class="form-control text-right" style="width: 4rem" [readonly]="isReadOnly$ | async"
                [ngModel]="orgArea.periods[tgtPeriodIndex].tgtRenewalPct | percent: '0.0-2'"
                (ngModelChange)="updateEstimatePct(estimateTypeEnumRef.TargetRenewalPct, $event)"
                (blur)="updateEstimateForce(estimateTypeEnumRef.TargetRenewalPct)" />
              <div class="input-group-append" *ngIf="!(isReadOnly$ | async)">
                <button type="button" class="btn btn-secondary" title="Set renewal leases from renewal target"
                  (click)="updateRenewalLeasesFromRenewalTarget()">
                  <i class="fas fa-bullseye"></i>
                  <span class="pl-1"> Set...</span>
                </button>
              </div>
            </div>
            <div class="small mt-1">{{cyLabel}}: {{orgArea.summary?.estOccRenewalPct | percent: '0.0-1'}}</div>
          </div>
        <div class="border rounded bg-white px-2 py-1" [ngClass]="getTargetEstimateClass(estimateTypeEnumRef.TargetOccupancyPct)">
            <label class="d-block small font-weight-bold mb-1" tccLabelForNext>Occupancy Target</label>
            <div class="input-group input-group-sm">
              <input class="form-control text-right" style="width: 4rem" [readonly]="isReadOnly$ | async"
                [ngModel]="orgArea.periods[tgtPeriodIndex].tgtOccPct | percent: '0.0-2'"
                (ngModelChange)="updateEstimatePct(estimateTypeEnumRef.TargetOccupancyPct, $event)"
                (blur)="updateEstimateForce(estimateTypeEnumRef.TargetOccupancyPct)" />
              <div class="input-group-append" *ngIf="!(isReadOnly$ | async)">
                <button type="button" class="btn btn-secondary" title="Set new leases from occupancy target"
                  (click)="updateNewLeasesFromOccupancyTarget()">
                  <i class="fas fa-bullseye"></i>
                  <span class="pl-1"> Set...</span>
                </button>
              </div>
            </div>
            <div class="small mt-1">{{cyLabel}}: {{orgArea.summary?.estOccPct | percent: '0.0-1'}}</div>
          </div>
        <div class="border rounded bg-white px-2 py-1" [ngClass]="getTargetEstimateClass(estimateTypeEnumRef.TargetRateIncreasePct)">
            <label class="d-block small font-weight-bold mb-1" tccLabelForNext>Target Rate Growth</label>
            <div class="input-group input-group-sm">
              <input class="form-control text-right" style="width: 4rem" [readonly]="isReadOnly$ | async"
                [ngModel]="orgArea.periods[tgtPeriodIndex].tgtRateIncreasePct | percent: '0.0-2'"
                (ngModelChange)="updateEstimatePct(estimateTypeEnumRef.TargetRateIncreasePct, $event)"
                (blur)="updateEstimateForce(estimateTypeEnumRef.TargetRateIncreasePct)" />
              <div class="input-group-append" *ngIf="!(isReadOnly$ | async)">
                <button type="button" class="btn btn-secondary" title="Set new rates from rate growth target"
                  (click)="updateNewRates()">
                  <i class="fas fa-hand-holding-usd"></i>
                  <span class="pl-1"> Set...</span>
                </button>
              </div>
            </div>
            <div class="small mt-1">{{cyLabel}}: {{orgArea.summary?.estRateGrowth | percent: '0.0-1'}}</div>
          </div>
        <div class="border rounded bg-white px-2 py-1">
            <span class="small font-weight-bold">{{cyLabel}} Revenue Growth</span>
            <div>{{orgArea.summary?.estRevenueGrowth | percent: '0.0-1'}}</div>
          </div>

        <div class="border rounded bg-white px-2 py-1">
          <div class="small font-weight-bold mb-1">Actions</div>
          <div class="btn-group btn-group-sm btn-light" ngbDropdown title="Leave/View Comments">
            <button class="btn" (click)="showComments(commentAccount)" ngbDropdownToggle>
              <i class="fas fa-comment"></i>
              <span class="pl-2 d-none d-lg-inline d-xl-inline">Comments</span>
            </button>
            <div ngbDropdownMenu style="z-index:10000">
              <button type="button" ngbDropdownItem (click)="showComments(specialAccounts.gpr)">GPR</button>
              <button type="button" ngbDropdownItem (click)="showComments(specialAccounts.vacancyLoss)">Vacancy
                Loss</button>
            </div>
          </div>
          <button class="btn btn-sm btn-light" title="View Fp Rate Summary" type="button"
            routerLink="./rate-summary">
            <i class="far fa-money-bill-alt"></i>
            <span class="pl-2 d-none d-lg-inline d-xl-inline">Rate Summary</span>
          </button>
          <span
            *ngIf="(userChangeSubject | async)?.features?.includes('Revenue') || (userChangeSubject | async)?.features?.includes('Admin')">
            <button class="btn btn-sm" title="Update Financial Plan" type="button" (click)="updateFp()"
              [ngClass]="(fpOutOfSync$ | async) ? 'btn-danger' : 'btn-light'"
              [disabled]="!(fpOutOfSync$ | async) || (isReadOnly$ | async)">
              <i class="fas fa-bolt"></i>
              <span class="pl-2 d-none d-lg-inline d-xl-inline">Update Fp</span>
            </button>
          </span>
        </div>
      </div>

      <div class="flex-shrink-1">
        <div class="btn-group">
          <button [routerLink]="['../..', 'rollup']" class="btn py-0 btn-light" title="Rollup">
            <i class="fas fa-dollar-sign"></i>
            <span class="pl-2 d-none d-lg-inline d-xl-inline">Rollup</span>
          </button>
          <button [routerLink]="['../..', (org$ | async)?.orgId,'renewals']" class="btn py-0 btn-light"
            [title]="'Renewals Planning for ' + (org$ | async)?.name">
            <i class="fas fas fa-funnel-dollar"></i>
            <span class="pl-2 d-none d-lg-inline d-xl-inline">Renewal Planning</span>
          </button>
        </div>
      </div>
    </div>
    <div style="margin: 6px -6px; margin-bottom: -14px" [hidden]="(trayRequest$ | async)?.trayId === 'none'">
      <comment-management *ngIf="(trayRequest$ | async)?.trayId === 'CommentManagement'"></comment-management>
    </div>
  </div>
  <div panel-body class="d-flex flex-column" style="margin: -15px">
    <div class="p-3 flex-shrink-1" style="overflow-y: auto">
      <div class="d-flex flex-row" *ngIf="(state$ | async) !== 'loading'">
        <app-amenity-averages class="flex-shrink-0 mr-2"></app-amenity-averages>
        <div class="flex-grow-1 flex-shrink-1" style="min-width:0">
          <div class="btn-group btn-group-sm mb-2" role="group" aria-label="Estimate view">
            <button type="button" class="btn"
              [ngClass]="showUnitTypeEstimates ? 'btn-secondary' : 'btn-light'"
              [attr.aria-pressed]="showUnitTypeEstimates"
              (click)="toggleUnitTypeEstimates()">
              Unit Types
            </button>
            <button type="button" class="btn"
              [ngClass]="showBedroomCountEstimates ? 'btn-secondary' : 'btn-light'"
              [attr.aria-pressed]="showBedroomCountEstimates"
              (click)="toggleBedroomCountEstimates()">
              Bedroom Counts
            </button>
          </div>
          <app-unit-types *ngIf="showUnitTypeEstimates" class="d-block mb-2"></app-unit-types>
          <app-bedroom-count-types *ngIf="showBedroomCountEstimates" class="d-block"></app-bedroom-count-types>
        </div>
      </div>

      <div class="mt-2 flex-grow-1" *ngIf="(state$ | async) !== 'loading'">
        <app-revenue-total></app-revenue-total>
      </div>
      <div class="mt-2 flex-grow-1" *ngIf="(state$ | async) !== 'loading'">
        <app-total></app-total>
      </div>
    </div>
    <tcc-loadingOverlay *ngIf="(state$ | async) !== 'ready'"></tcc-loadingOverlay>
  </div>
</tcc-simplePanel>
<router-outlet></router-outlet>
